import { useEffect, useState } from "react";

const navItems = [
  { id: "overview", label: "事件一览" },
  { id: "graph", label: "人物图谱" },
  { id: "persons", label: "核心人物" },
  { id: "relations", label: "关系解析" },
  { id: "timeline", label: "时间脉络" },
  { id: "faq", label: "常见问题" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-[#fbf6ef]/95 backdrop-blur border-b border-[#eadccb]" : "bg-transparent"
      }`}
    >
      <nav className="mx-auto flex max-w-6xl items-center justify-between px-4 md:px-6 py-3">
        <a href="#top" className="flex items-center gap-2 whitespace-nowrap">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-[#b4372a] text-white">
            <i className="ri-node-tree text-lg" aria-hidden="true"></i>
          </span>
          <span className="font-serif-sc text-lg font-bold text-[#2a2320]">吃瓜门图谱</span>
        </a>

        <div className="hidden items-center gap-1 lg:flex">
          {navItems.map((it) => (
            <a
              key={it.id}
              href={`#${it.id}`}
              className="rounded-md px-3 py-2 text-sm whitespace-nowrap text-[#5a5049] transition hover:bg-[#efe3d2] hover:text-[#b4372a]"
            >
              {it.label}
            </a>
          ))}
          <a
            href="#faq"
            className="ml-2 rounded-md bg-[#b4372a] px-4 py-2 text-sm whitespace-nowrap text-white transition hover:bg-[#98301f]"
          >
            看懂全貌
          </a>
        </div>

        <button
          className="flex h-9 w-9 items-center justify-center rounded-md text-[#2a2320] lg:hidden"
          onClick={() => setOpen((v) => !v)}
          aria-label="展开导航"
        >
          <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"} aria-hidden="true"></i>
        </button>
      </nav>

      {open && (
        <div className="border-t border-[#eadccb] bg-[#fbf6ef] px-4 pb-4 pt-2 lg:hidden">
          {navItems.map((it) => (
            <a
              key={it.id}
              href={`#${it.id}`}
              onClick={() => setOpen(false)}
              className="block rounded-md px-3 py-2 text-sm text-[#5a5049] hover:bg-[#efe3d2] hover:text-[#b4372a]"
            >
              {it.label}
            </a>
          ))}
        </div>
      )}
    </header>
  );
}